// Legacy keyword (SMS-ish) voting for Deloitte
export default async function legacyVote (state, appOptions) {
  const LegacyVote = (await import(/* webpackChunkName: 'pollev-legacy-vote' */ '../../participant-components/home/legacy_vote')).default

  return new LegacyVote({ state })
}
